import React from 'react'
import { withRouter } from 'react-router-dom'

function RecipeCard(props) {
    const toDetails = () => {
        props.history.push("/recipedetails")
    }

    return (
        <div className="RecipeCard" onClick={toDetails}>
            <img src={props.recipe.recipe.image} alt="Not available"/>
            <div className="title">{props.recipe.recipe.label}</div>
            <div className="time">Cooking Time: {props.recipe.recipe.totalTime}</div>
            <div className="servings">Servings: {props.recipe.recipe.yield}</div>

            {/* <div className="ingredients">
                {props.recipe.ingredients.map(ingredient => <div className="ingredient">{ingredient}</div>)}
            </div> */}
        </div>
    )
}

export default withRouter(RecipeCard)